import React from "react"
import dayjs from "util/dayjs-init.js";
import "dayjs/locale/ja";
import { CalendarIcon, ClockIcon, LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs"
import { useSelector } from "react-redux";
import { selectedTimezone } from "../../model/slice/timezoneSlice";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { TIMEZONE } from "../../constants/timezone";
import { useTranslation } from "react-i18next";

export const MUIDatePicker = ({ date, setDateFunction, isStart, limitationDate}) => {
  const { i18n } = useTranslation();
  const isJa = i18n.language === 'ja';
  const timezone = useSelector(selectedTimezone);
  const isUTC = timezone === TIMEZONE.UTC;
  const maxDate = isStart ? dayjs(limitationDate) : dayjs();

  const updateDate = (e) => {
    setDateFunction(dayjs(e));
  }

  const CustomActionBar = ({onAccept, onCancel}) => {
    return (
      <Box sx={{gridColumn: 2, gridRow: 3, display: 'flex', justifyContent: 'end', position: 'relative', bottom: '12px', right: '12px'}}>
        <Button onClick={onCancel} sx={{backgroundColor: '', color: '#28B6C7'}}>Cancel</Button>
        <Button onClick={onAccept} sx={{backgroundColor: '#28B6C7', color: 'white'}}>OK</Button>
      </Box>
    )
  }

  CustomActionBar.propTypes = {
    onAccept: PropTypes.func,
    onCancel: PropTypes.func,
  };

  return(
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
      <MobileDatePicker 
        value={dayjs(date)} 
        onAccept={updateDate} 
        timezone={isUTC ? TIMEZONE.UTC : "default"} 
        maxDate={maxDate}
        slots={{actionBar: CustomActionBar}}
        sx={{
          '& input': {color: 'white', cursor: 'pointer', padding: '4px 12px'}, 
          '& input::selection' : {backgroundColor: 'transparent'},
          background: '#2f3a47', 
          width: '100%',
        }}
        slotProps={{
          mobilePaper: {sx : {background: '#2f3a47', color: 'white'}}, 
          leftArrowIcon: {sx: {color: 'white'}},
          rightArrowIcon: {sx: {color: 'white'}},
          tabs: {
            dateIcon: <CalendarIcon sx={{fill: "white"}} />,
            timeIcon: <ClockIcon sx={{fill: 'white'}} />,
            sx: {'.MuiTabs-indicator': {backgroundColor: '#28B6C7'}}
          },
          toolbar: {
            toolbarFormat: isJa ? 'MM月DD日' : 'MMM DD',
            sx: {'& span': {color: 'white'}, '& span.Mui-selected': {color: 'white'}}
          },
          mobileTransition: {
            sx: {'&.MuiDayCalendar-weekDayLabel': {color: 'white'}}
          },
          calendarHeader: {
            format: isJa ? "YYYY年 MM月" : 'YYYY/MM',
            sx:{'& span' : {color: 'white'}, '& svg': {fill: 'white'}, '&.MuiPickersCalendarHeader-root': {color: 'white'}, 'MuiPickersDay-root': {color: 'white'}}
          },
          day: {
            sx: {
              color: 'white', 
              '&.MuiPickersDay-today:not(.Mui-selected)': {border: '1px solid rgba(255, 255, 255, 0.6)'}, 
              '&.MuiPickersDay-root.Mui-selected': {backgroundColor: '#28B6C7'},
            },
          },
          layout: {
            sx: {
                  '& .MuiDayCalendar-weekDayLabel': {
                    color: 'white',
                  },
                  '& .MuiClockNumber-root': {
                    color: 'white'
                  },
                  '& .MuiClock-pin': {
                    backgroundColor: '#28B6C7'
                  },
                  '& .MuiClockPointer-root': {
                    backgroundColor: '#28B6C7'
                  },
                  '& .MuiClockPointer-thumb': {
                    backgroundColor: '#28B6C7',
                    border: '16px solid #28B6C7'
                  }
            }
          }
        }}
        />
    </LocalizationProvider>
  )
}
MUIDatePicker.propTypes = {
  isSEPVessel: PropTypes.bool,
  date: PropTypes.string,
  setDateFunction: PropTypes.func,
  isStart: PropTypes.bool,
  limitationDate: PropTypes.string,
}